import { lazy } from 'react';

import { DailyEndScreen } from '../../components/dailyEnd/DailyEndScreen';
import { useTodaysCountry } from '../../providers/TodaysCountryProvider';
import { MainGameRoute } from './MainGameRoute';

const LazyFirstBonusRoundRoute = lazy(() =>
  import(
    /* webpackChunkName: "FirstBonusRoundRoute", webpackPreload: true */ './ShapeGameRoute'
  ).then((module) => ({
    default: module.ShapeGameRoute,
  })),
);

const LazySecondBonusRoundRoute = lazy(() =>
  import(
    /* webpackChunkName: "LazySecondBonusRoundRoute", webpackPreload: true */ './NationalEmblemGameRoute'
  ).then((module) => ({
    default: module.CoatOfArmsGameRoute,
  })),
);

const LazyThirdBonusRoundRoute = lazy(() =>
  import(
    /* webpackChunkName: "LazyThirdBonusRoundRoute", webpackPreload: true */ './CapitalFlagGameRoute'
  ).then((module) => ({
    default: module.CapitalFlagGameRoute,
  })),
);

const LazyFourthBonusRoundRoute = lazy(() =>
  import(
    /* webpackChunkName: "FourthBonusRoundRoute", webpackPreload: true */ './BorderFlagGameRoute'
  ).then((module) => ({
    default: module.BorderFlagGameRoute,
  })),
);

const LazyFifthBonusRoundRoute = lazy(() =>
  import(
    /* webpackChunkName: "FifthBonusRoundRoute", webpackPreload: true */ './QuizGameRoute/QuizGameRoute'
  ).then((module) => ({
    default: module.QuizGameRoute,
  })),
);

const Round = () => {
  const { currentRound, isPrankMode, isDayEnd } = useTodaysCountry();

  if (isDayEnd) return <DailyEndScreen />;

  switch (currentRound.name) {
    case 'Shape':
      return <LazyFirstBonusRoundRoute />;
    case 'Emblem':
      return <LazySecondBonusRoundRoute />;
    case 'Capital flag':
      return <LazyThirdBonusRoundRoute />;
    case 'Neighbours':
      return <LazyFourthBonusRoundRoute />;
    case 'Population & Currency':
      return <LazyFifthBonusRoundRoute />;
    default:
      return <MainGameRoute key={isPrankMode ? 'prank' : 'real'} />;
  }
};

export default Round;
